<template>
     <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          dark
          v-bind="attrs"
          v-on="on"
          class="d-inline-block text-truncate"
          :style="`max-width: ${maxW}`"
        >{{content}}</span>
      </template>
      <span>{{content}}</span>
    </v-tooltip>
</template>

<script>
    export default {
        props:['content','maxW']
    }
</script>

<style lang="scss" scoped>

</style>